import React, { Component } from 'react';
import { Modal, Loading } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { TableDefault } from '../../../../components';
import {
  PRODUCAO,
  CONCLUIDO,
  CANCELADO,
  APROVADO,
  CRIACAO,
  TRANSPORTE
} from '../../../../config/StatusRequest';
import { pathDmService } from '../../../../services/Api';


class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      typeCleark: 1,
      type: null,
      orderBy: 'pedido',
      // orderDirection: '',
      // urlDelete: '/Pedido/Delete',
      urlEdit: '/trade/admin/campanhas-promocionais/editar/',
      urlLoad: '/Pedido/GetCampanhaPromocionalAtendente/',
      // messageNextModal: 'Você tem certeza que deseja alterar o status do pedido',
      actionModal: false,
      numberRequest: [],
      statusRequest: null,
      newStatusRequest: null,
      selectedFilter: null,
      isSaving: false,
      ids:[],
      id:null
    };
  }

  componentDidMount() {
    this.setSatus("");
  }
  
  setSatus = status => {
    let newStatus = {};
    switch (status) {
      case 'Pendente':
        newStatus = APROVADO;
        break;
      case 'Aprovado':
        newStatus = CRIACAO;
        break;
      case 'Criação':
        newStatus = PRODUCAO;
        break;
      case 'Produção':
        newStatus = TRANSPORTE;
        break;
      case 'Transporte':
        newStatus = CONCLUIDO;
        break;        
      case 'Concluído':
        newStatus = CANCELADO;
        break;
      default:
        newStatus = null;
        break;
    }

    this.setState({
      newStatusRequest: newStatus,
    });
  };

  actionNext = event => {
    this.setSatus(event.cells[4].value);
    this.setState(prevState => ({
      actionModal: !prevState.actionModal,
      selectedId: null,
      numberRequest: [event.cells[0].value],
      statusRequest: event.cells[4].value,
      id: event.id
    }));
  };

  closeModalNext = () => {
    this.setState({
      actionModal: false,
    });
  };

  updateStatus = () => {
    const { id, ids, newStatusRequest } = this.state;
    const { history } = this.props;
    const url = `/Pedido/AtualizaStatusLote/${id || ids.join(',')}?status=${ newStatusRequest ? newStatusRequest.id : null}&retirouUniforme=&dataRetiradaUniforme=`;
    this.setState({ isSaving: true });
    pathDmService(url, {})
      .then(() => {
        toast.success('Status atualizado com sucesso.');
        setTimeout(() => {
          this.setState({
            actionModal: false,
            isSaving: false,
          });
          // window.location.href = history.location.pathname;
          history.push(history.location.pathname)
        }, 1800);
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o status.');
        this.setState({ isSaving: false });
      });
  };

  selectedRow = obj => {
    console.log(this.state)
    const numberRequest = []
    if(obj.rows && obj.rows.length > 0) {
      this.setSatus(obj.rows[0].cells[4].value);
      this.setState({statusRequest: obj.rows[0].cells[4].value})
      obj.rows.forEach(item=> {
        numberRequest.push(item.cells[0].value);
      })
    } 
    this.setState({id:null, ids : obj.ids, numberRequest})
  }


  render() {
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      actionModal,
      numberRequest,
      statusRequest,
      newStatusRequest,
      selectedFilter,
      type,
      isSaving,
      typeCleark,
      ids
    } = this.state;

    const { defaultFilters, location, showCheck } = this.props;
    const { pathname} = location
    // console.log("test log")
    const isConlused = pathname === "/trade/admin/campanhas-promocionais/lista/concluido"
    const rowSelect = {}
    if(showCheck) {
      rowSelect.onRowSelected= rows => {
        this.selectedRow(rows);
      };
    }
    return (
      <div className="table-uniforms">
        {showCheck && (
          <button
            disabled={!(ids && ids.length > 0)}
            className="bx--btn btn-secondary-color h-sm-margin"
            style={{marginBottom:10}}
            type="button"
            onClick={() => this.setState({actionModal:true})}
          >
            Alterar status
          </button>
        )}
        {isConlused ? (
          <TableDefault
            search={search}
            defaultFilters={defaultFilters}
            typeCleark={typeCleark}
            type={type}
            order={order}
            orderBy={orderBy}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            idxStatus={4}
            selectedFilter={selectedFilter}
            {...this.props}
          />
        ) :
          (
            <TableDefault
              {...rowSelect}
              search={search}
              defaultFilters={defaultFilters}
              typeCleark={typeCleark}
              type={type}
              order={order}
              orderBy={orderBy}
              pageSize={pageSize}
              totalItems={totalItems}
              urlDelete={urlDelete}
              urlEdit={urlEdit}
              urlLoad={urlLoad}
              actionNext={this.actionNext}
              idxStatus={4}
              selectedFilter={selectedFilter}
              {...this.props}
            />
          )

        }
       

        <Modal
          open={actionModal}
          onRequestSubmit={() => this.updateStatus()}
          onRequestClose={() => this.closeModalNext()}
          modalHeading="Alteração de Status"
          primaryButtonText="Confirmar"
          secondaryButtonText="Cancelar"
        >
          <div>
            <p>
              {`Você tem certeza que deseja alterar o status ${numberRequest.length > 1 ? "dos pedidos" : "do pedido"} `}
              <strong> 
                {numberRequest.join(', ')}
              </strong>
              de
              <strong> 
                {' '}
                {statusRequest}
                {' '}
              </strong>
              {' '}
para
              {' '}
              <strong>{newStatusRequest ? newStatusRequest.value : null}</strong>
?
            </p>
          </div>
        </Modal>

        {isSaving && <Loading small />}
      </div>
    );
  }
}
export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Campaign/Items.js